import type { GameAttribution } from '../../app/data/attribution-types.js'
import { repositoryCodeLicense } from '../../app/data/attribution-types.js'

export const trainSoundsAttribution: GameAttribution = {
  slug: 'train-sounds',
  name: 'Train Sounds',
  codeLicense: repositoryCodeLicense,
  entries: [
    {
      title: 'Train Sounds hotspot routing and electric hum brightener',
      type: 'sound effect',
      usedIn: 'Train Sounds shared hotspot playback bus and the quiet harmonic layer tucked under the electric commuter hum route',
      creator: 'Peninsular Reveries',
      source: 'Generated in-browser with the Web Audio API',
      license: repositoryCodeLicense,
      modifications: 'Not applicable.',
      notes: 'The recorded electric hum remains the primary sound. The synth layer only adds a faint harmonic edge so the cue reads more reliably on small speakers.',
    },
    {
      title: 'steam-train-whistle.wav',
      type: 'sound effect',
      usedIn: 'Train Sounds Steam Flyer whistle hotspot',
      creator: 'gadzooks',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/gadzooks/sounds/188240/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed to a 1.42 second mono 60 kbps OGG whistle with light band-limiting and short fades.',
    },
    {
      title: 'EMD Steel Bell',
      type: 'sound effect',
      usedIn: 'Train Sounds Steam Flyer bell hotspot',
      creator: 'chungus43A',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/chungus43A/sounds/705377/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed from the bell strike into a compact 0.82 second mono OGG and filtered to keep the ring clear.',
    },
    {
      title: 'single steam train chuff',
      type: 'sound effect',
      usedIn: 'Train Sounds Steam Flyer drive-rod hotspot',
      creator: 'birdOfTheNorth',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/birdOfTheNorth/sounds/623817/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.66 second mono OGG chuff with tight fades and mid-band focus.',
    },
    {
      title: 'Diesel Locomotive Horn - 2300 Class.wav',
      type: 'sound effect',
      usedIn: 'Train Sounds Diesel Hauler horn hotspot',
      creator: 'JotrainG',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/JotrainG/sounds/662553/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed to a 0.84 second mono OGG horn burst with modest band-limiting and fade shaping.',
    },
    {
      title: 'Diesel engine idling',
      type: 'sound effect',
      usedIn: 'Train Sounds Diesel Hauler engine-hum and wheel hotspots',
      creator: 'chungus43A',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/chungus43A/sounds/705386/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.92 second mono OGG idle looplet and reused at a faster playback rate for the diesel wheel texture.',
    },
    {
      title: 'Air (or steam) pressure release',
      type: 'sound effect',
      usedIn: 'Train Sounds diesel, electric, and high-speed brake hotspots',
      creator: 'brunoboselli',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/brunoboselli/sounds/457294/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.96 second mono OGG hiss and reused with slight playback-rate offsets across the brake cues.',
    },
    {
      title: 'Moscow Metro 81-717 two chime horn',
      type: 'sound effect',
      usedIn: 'Train Sounds Electric Commuter horn hotspot',
      creator: 'chungus43A',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/chungus43A/sounds/783760/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed from the recorded preview into a 0.52 second mono OGG horn hit with short fades.',
    },
    {
      title: '200/300Hz 81-717 BPSN hum sound',
      type: 'sound effect',
      usedIn: 'Train Sounds Electric Commuter power-hum hotspot and the electric wheel variant',
      creator: 'chungus43A',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/chungus43A/sounds/733740/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed to a 0.96 second mono OGG hum with stronger mid-band filtering; the base clip remains primary while a very low-gain harmonic layer supports only the electric power-hum route.',
    },
    {
      title: 'Old Toronto Subway Chime',
      type: 'sound effect',
      usedIn: 'Train Sounds Steam Flyer, Electric Commuter, and High-Speed Arrow passenger-door hotspots',
      creator: 'chungus43A',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/chungus43A/sounds/720572/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.68 second mono OGG chime and reused with small playback-rate changes across the passenger-door cues.',
    },
    {
      title: 'Train horn, Departs',
      type: 'sound effect',
      usedIn: 'Train Sounds High-Speed Arrow horn hotspot',
      creator: 'OroborosNZ',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/OroborosNZ/sounds/141273/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.82 second mono OGG horn cue with light band-limiting and quick fades.',
    },
    {
      title: 'TRNHspd_High Speed, Pass-By, Passenger Train, Mono Mix, Recording_02_JW Audio',
      type: 'sound effect',
      usedIn: 'Train Sounds High-Speed Arrow wheel and power-hum hotspots',
      creator: 'JW_Audio',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/JW_Audio/sounds/844230/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 1.34 second mono OGG pass-by and reused at a slower rate for the high-speed power-hum cue.',
    },
    {
      title: 'R20-33-Train Cars Coupling.wav',
      type: 'sound effect',
      usedIn: 'Train Sounds Steam Flyer coupler hotspot and Diesel Hauler cargo-latch hotspot',
      creator: 'craigsmith',
      source: 'Freesound',
      sourceUrl: 'https://freesound.org/people/craigsmith/sounds/480819/',
      license: 'Creative Commons 0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      modifications: 'Trimmed into a 0.64 second mono OGG clank and reused with a slightly slower playback rate for the cargo latch.',
    },
  ],
}